import React from 'react';
import PropTypes from 'prop-types';

const FallbackContentAnimation = ({
  loading,
  fallback,
  repeat = 1,
  children,
}) => {
  if (loading) {
    const count = Math.max(1, parseInt(repeat, 10) || 1);
    return (
      <>
        {Array.from({ length: count }, (_, index) => (
          <React.Fragment key={index}>{fallback}</React.Fragment>
        ))}
      </>
    );
  }
  return children || null;
};
FallbackContentAnimation.propTypes = {
  loading: PropTypes.bool,
  fallback: PropTypes.node.isRequired,
  repeat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
};
FallbackContentAnimation.defaultProps = {
  loading: false,
  repeat: 1,
  children: null,
};
export default FallbackContentAnimation;
